<template>
<div>
    <pt-sub-title title="个人上传"></pt-sub-title>
     <wt-paged-table :on-request-data="getTableData" :total-size="totalNumber" :page-size="pageSize" ref="table">
        <wt-table :list="tableData" :labels="tableLabels">
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-button type="text" @click="recordDetail(scope.row)">详情</el-button>
                </template>
            </el-table-column>
        </wt-table>
    </wt-paged-table>
</div>
</template>
<script>
export default {
  props: {
    pageSize: {
      type: Number,
      default: 10
    },
    id: {
      type: String,
      default: ''
    },
    tableLabels: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data () {
    return {
      tableData: [],
      totalNumber: 0
    }
  },
  methods: {
    recordDetail (row) {
      this.$router.push('/all-customer/health-record-detail/' + row.id)
    },
    getTableData (page, next) {
      let data = {
        data: {
          example: {
            userId: this.id
          },
          pageable: {
            page: page,
            size: this.pageSize
          }
        },
        type: 'SELF'
      }
      this.$store.dispatch('healthRecords', data).then(res => {
        this.tableData = res.data
        this.totalNumber = res.totalNumber
        if (next) {
          next(res.data)
        }
      }).catch(err => {
        this.$message.error(err || '获取健康档案失败')
      })
    }
  }
}
</script>
<style module lang="less">

</style>
